import { GET_IMPERSONATION_USERS } from '../actions/impersonationActions';

/**
 * Manejo de la parte del estado correspondiente a los usuarios de impersonación.
 * Permite obtener la lista de usuarios que pueden ser impersonados.
 *
 * @export
 * @param {*} [state={}] : estado de la aplicación
 * @param {*} action : operación a realizar sobre el estado (correspondiente a los usuarios de impersonación)
 * @returns El estado con la modificación/acción realizada.
 */
const initialState = {
  users: [],
  loading: true
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_IMPERSONATION_USERS:
      return {
        ...state,
        users: action.payload.users,
        loading: false
      };
    default:
      return state;
  }
} 